import { ChangeDetectorRef, Component, OnInit, ViewChild, inject } from '@angular/core';
import { UntypedFormBuilder, ReactiveFormsModule } from '@angular/forms';
import { GeographyFilterComponent } from 'src/app/features/search/components/filters/geography-filter/geography-filter.component';
import { OrgTreeFilterComponent } from 'src/app/features/search/components/filters/org-tree-filter/org-tree-filter.component';
import { GeoEnum } from 'src/app/features/search/enums/geo.enum';
import { SearchService } from 'src/app/features/search/search.service';
import { SearchBaseComponent } from '../../../search/components/search-base/search-base.component';
import {
  SearchFilterContainerConfig,
  SearchFilterContainerComponent
} from '../../../search/components/search-filter-container/search-filter-container.component';
import { getIdsFromItemFormControl } from '../../../search/search.utils';
import { SearchFilterService } from '../../../search/services/search-filter.service';
import { UserSearchModel } from '../../models/user-search.model';
import { WsHelperService } from '@shared/services/ws-helper.service';
import { OrgTreeEnum } from '@src/app/features/search/enums/org-tree.enum';
import {
  SearchFilterColumnsComponent,
  SearchFilterColumnDirective
} from '../../../search/components/search-filter-columns/search-filter-columns.component';
import { UserRoleFilterComponent } from '../../../search/components/filters/user-role-filter/user-role-filter.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { OrgTreeFilterComponent as OrgTreeFilterComponent_1 } from '../../../search/components/filters/org-tree-filter/org-tree-filter.component';
import { GeographyFilterComponent as GeographyFilterComponent_1 } from '../../../search/components/filters/geography-filter/geography-filter.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'stx-user-search',
  templateUrl: './user-search.component.html',
  imports: [
    SearchFilterContainerComponent,
    ReactiveFormsModule,
    SearchFilterColumnsComponent,
    SearchFilterColumnDirective,
    UserRoleFilterComponent,
    MatCheckbox,
    OrgTreeFilterComponent_1,
    GeographyFilterComponent_1,
    TranslateModule
  ]
})
export class UserSearchComponent extends SearchBaseComponent implements OnInit {
  private formBuilder = inject(UntypedFormBuilder);
  private searchService = inject(SearchService);
  private cd = inject(ChangeDetectorRef);
  private readonly wsHelperService = inject(WsHelperService);

  readonly userSearchFilterContainerConfig: SearchFilterContainerConfig = {
    isCsvAvailable: true,
    routerLink: { icon: 'add_circle_outline', text: 'user.user_new', url: '/users/new' }
  };
  GeoEnum = GeoEnum;
  @ViewChild(GeographyFilterComponent, { static: true }) geoFilter: GeographyFilterComponent;
  @ViewChild(OrgTreeFilterComponent, { static: true }) orgTreeFilter: OrgTreeFilterComponent;

  constructor() {
    const searchFilterService = inject(SearchFilterService);

    super(searchFilterService);
  }

  ngOnInit() {
    this.initializeUserSearchForm();
    this.loadFilters();
  }

  protected getSearchFilters(): UserSearchModel {
    return Object.assign(
      {},
      this.searchFormGroup.value,
      this.getOrgTreeRequestParams(),
      this.getGeoographyTreeRequestParams(),
      this.getRolesRequestdata()
    );
  }

  private initializeUserSearchForm(): void {
    this.searchFormGroup = this.formBuilder.group({
      active: [false],
      inactive: [false],
      loggedInToday: [false],
      domainAccess: [false],
      roles: [[]],
      partners: [[]],
      treatmentCenters: [[]],
      countries: [[]],
      crmRegions: [[]]
    });
  }

  get geoTreePartialUserFiltersType(): OrgTreeEnum {
    return OrgTreeEnum.PARTNERS;
  }

  private loadFilters(): void {
    this.subSink.sink = this.wsHelperService.callWithSpinner(this.searchService.getOrgTreeFilters()).subscribe(filters => {
      this.orgTreeFiltersData = filters;
      this.cd.detectChanges();
    });
  }

  private getOrgTreeRequestParams(): Record<string, string[]> {
    const keysToMap = ['partners'];

    return getIdsFromItemFormControl(this.searchFormGroup, keysToMap);
  }

  private getGeoographyTreeRequestParams(): Record<string, string[]> {
    const keysToMap = ['crmRegions', 'countries'];

    return getIdsFromItemFormControl(this.searchFormGroup, keysToMap);
  }

  private getRolesRequestdata(): Record<string, string[]> {
    const keysToMap = ['roles'];

    return getIdsFromItemFormControl(this.searchFormGroup, keysToMap);
  }
}
